import { ChangeDetectionStrategy, Component, output, inject, input, signal } from '@angular/core';
import { IBanner } from '@mogenius/core/interfaces/banner.interface';
import { MoNgUtils } from '@mogenius/core/mo-ng-utils';
import { NotificationService } from '@mogenius/shared/services/notification.service';

import { SafeHtmlPipe } from '../../../pipes/safteHtml.pipe';

@Component({
    selector: 'mo-notification-banner-list-item',
    templateUrl: './notification-banner-list-item.component.html',
    styleUrl: './notification-banner-list-item.component.scss',
    imports: [SafeHtmlPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationBannerListItemComponent {
  private readonly _notificationService = inject(NotificationService);

  readonly banner = input.required<IBanner>();
  readonly closeBanner = output<void>();

  // Local feedback instead of a "Copied to clipboard" toast: a toast raised from
  // inside a toast would shift the banner the user is still reading.
  readonly copied = signal(false);

  public pause(): void {
    this._notificationService.pause(this.banner());
  }

  public resume(): void {
    this._notificationService.resume(this.banner());
  }

  // The failing request is the part nobody wants to retype off a screenshot.
  public copyDetail(): void {
    const detail = this.banner().detail;
    if (!detail) {
      return;
    }
    MoNgUtils.copyToClipboard(detail);
    this.copied.set(true);
    setTimeout(() => this.copied.set(false), 1500);
  }
}
